import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { TwoFactorVerify } from '@ibk/shared-auth';
import { Card } from '@ibk/shared-ui';
import styles from './TwoFactorVerify.module.css';
import { useTwoFactorVerify } from './useTwoFactorVerify';
export default function TwoFactorVerifyPage({ bpo = false }) {
    const { state } = useLocation();
    const verifyProps = useTwoFactorVerify(state || {});
    return (_jsx("main", { className: bpo ? styles.bpoContainer : styles.container, children: _jsx(Card, { padding: 36, borderRadius: 8, style: bpo ? undefined : { maxWidth: 340, width: '100%' }, className: bpo ? styles.bpoCard : styles.card, children: _jsx(TwoFactorVerify, { maskedRecipient: verifyProps.maskedRecipient || '', method: verifyProps.method, disabled: verifyProps.disabled, error: verifyProps.error, onBack: verifyProps.onBack, onContinue: verifyProps.onContinue, onResend: verifyProps.onResend, theme: {
                    primaryColor: '#d64000',
                    linkColor: '#1573D3',
                } }) }) }));
}
